<template>
  <div class="tw-flex tw-flex-col tw-gap-[25px] tw-w-full tw-relative actions">
    <div
      class="tw-text-xs tw-text-[12px] tw-font-semibold tw-leading-[100%] tw-tracking-[1.2px] tw-uppercase actions-header"
    >
      {{ getUiText("app-settings-action-menu-title-1") }}
    </div>
    <div
      v-for="(action, index) of profileActions"
      :id="
        action.title === 'app-settings-team-roles-more-modal-delete-role-1' &&
        !onUpdateAction
          ? `'popover-action-button-${member?.length}'`
          : action.id
            ? `${action.id}`
            : ''
      "
      :key="index"
      :data-cy="action.title"
      :class="`tw-flex tw-w-full tw-justify-between tw-items-center tw-cursor-pointer action ${action.class}`"
      @mouseover="onDeleteRole"
      @click="handleActionClick(action)"
    >
      <span
        :class="`tw-flex tw-items-center tw-flex-1 tw-text-[15px] tw-font-medium tw-leading-[100%] tw-gap-[10px] title_wrapper  ${
          member?.length === 0 && action.icon.__name === 'deleteIcon'
            ? 'disable'
            : ''
        } ${
          member?.length > 0 && action.icon.__name === 'deleteIcon'
            ? 'disable'
            : ''
        } ${
          !disable &&
          member?.length === 0 &&
          action.icon.__name === 'deleteIcon'
            ? 'remove'
            : ''
        }`"
      >
        <span
          class="tw-w-[34px] tw-h-[34px] tw-flex tw-items-center tw-justify-center tw-rounded-[50%] icon_wrapper"
        >
          <img
            v-if="typeof action.icon === 'string'"
            :src="action.icon"
            alt="reset_password"
            class="tw-h-[16px] tw-w-[16px] icon"
          />
          <component
            :is="action.icon"
            v-else
            :color="action.iconColor"
            class="tw-h-[18px] tw-w-[18px]"
          />
        </span>
        <span :class="`tw-flex-1 tw-text-[15px] ${action.titleClass}`">
          {{ getUiText(action.title) }}
        </span>
      </span>
      <span
        :class="`right-arrow
         ${
           member?.length > 0 && action.icon.__name === 'deleteIcon'
             ? 'disable'
             : ''
         } ${
           member?.length === 0 && action.icon.__name === 'deleteIcon'
             ? 'remove'
             : ''
         }  ${
           member?.length === 0 &&
           action.icon.__name === 'deleteIcon' &&
           disable
             ? 'demo'
             : ''
         }`"
      >
        <ArrowRightIcon />
      </span>
    </div>
    <div v-if="length">
      <CustomDropDown
        :id-popover="`'popover-action-button-${member?.length}'`"
        custom-class="red-tooltip"
      >
        <template #default>
          <div>
            {{
              getUiText(
                "app-settings-team-roles-manage-role-bulk-actions-delete-role-warning-1",
              )
            }}
          </div>
        </template>
      </CustomDropDown>
    </div>
  </div>
</template>

<script lang="ts">
import store from "@/store";
import utilities from "@/utils/utilities";
import { Component, Prop, Vue } from "vue-facing-decorator";
import CustomDropDown from "./customDropDown.vue";
import ArrowRightIcon from "@/components/svgs/arrowRightIcon.vue";

export type Action = {
  id?: string;
  icon: any;
  iconColor?: string;
  title: string;
  class?: string;
  titleClass?: string;
  onClick?: () => void;
  event?: object;
};

@Component({ components: { CustomDropDown, ArrowRightIcon: ArrowRightIcon } })
export default class ActionButton extends Vue {
  @Prop({ required: true }) readonly profileActions: Action[] = [];
  @Prop({ default: false }) public onUpdateAction!: boolean;
  @Prop({ default: [] }) public member = [];
  @Prop({ default: false }) readonly disable: boolean = false;
  @Prop({ default: false }) readonly length: boolean = false;

  showtooltipDelete = false;
  idPopOver = "popover" + Math.random() * 1000;

  get languageSelected() {
    return store.state.LanguagePicker.languageSelected;
  }
  get defaultUiText() {
    return store.state.LanguagePicker.defaultUiText;
  }
  get languageSelectedText() {
    return store.state.LanguagePicker.languageSelectedText;
  }

  getUiText(id: string, isArray = false) {
    return utilities.getUiText(
      id,
      this.languageSelectedText,
      this.defaultUiText,
      isArray,
    );
  }

  onDeleteRole = () => {
    this.showtooltipDelete = true;
  };
  handleActionClick(action: Action) {
    if (
      (this.member.length == 0 ||
        action.title !== "app-settings-team-roles-more-modal-delete-role-1") &&
      action.onClick &&
      !this.disable
    ) {
      action.onClick();
    }
  }
}
</script>

<style scoped>
.actions .actions-header {
  font-family: "Poppins";
  color: #211f58;
}

.actions .action .title_wrapper {
  font-family: "Poppins";
  color: #211f58;
}
.actions .action .right-arrow {
  color: #387dff;
}

.actions .action.disable .title_wrapper,
.actions .action.disable .right-arrow {
  color: #b7b7b7;
}

.actions .action.delete .title_wrapper,
.actions .action.delete .right-arrow {
  color: #f7553c;
}
.disable {
  color: #b7b7b7 !important;
}
.disable .right-arrow {
  color: #b7b7b7 !important;
}
.remove {
  color: #f7553c !important;
}
.demo {
  color: #b7b7b7 !important;
}
.actions .action.disable .title_wrapper .title {
  color: #b7b7b7;
}
</style>
